import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'

function GotoLocations({ setRoute }) {
  const { popDialog } = useDialog()

  useEffect(() => {
    if (setRoute) {
      setRoute('/location-selection')
    }
    popDialog()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}

GotoLocations.propTypes = {
  setRoute: PropTypes.func,
}

export default GotoLocations
